import ModelTitleCard from './modelTitleCard.container';

export default ModelTitleCard;